import {assertTokenValidForMutation, handleResponse} from "@/services/service-helpers"

const VALIDATE_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/auth/email-verification/validate`
const CONFIRM_URL = `${import.meta.env.VITE_NBH_URL_ROOT}/api/my-account/email/confirm`

export async function validateEmailVerificationToken(token: string): Promise<{ valid: boolean }> {
    try {
        const response = await fetch(`${VALIDATE_URL}?token=${encodeURIComponent(token)}`, {
            method: "GET",
        })
        return await handleResponse<{ valid: boolean }>(response) as { valid: boolean }
    } catch {
        return {valid: false}
    }
}

export class EmailVerificationUserMismatchError extends Error {
    constructor() {
        super("token_user_mismatch")
        this.name = "EmailVerificationUserMismatchError"
    }
}

export async function confirmEmailVerification(token: string, jwt: string): Promise<void> {
    assertTokenValidForMutation()
    const response = await fetch(CONFIRM_URL, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${jwt}`,
        },
        body: JSON.stringify({token}),
    })
    if (response.status === 403) {
        throw new EmailVerificationUserMismatchError()
    }
    if (!response.ok) {
        const error = await response.json().catch(() => ({error: "Unknown error"}))
        throw new Error(error.error || "Email verification failed")
    }
}
